<script>
export default {
  props: {
    value: {
      default: '',
    },
    items: {
      default: null,
      type: Array,
    },
  },
}
</script>

<template>
  <b-form-group id="input-group-4" v-slot="{ checkBox }">
    <b-form-checkbox-group v-model="value" id="checkboxes-4" :aria-describedby="checkBox">
      <b-form-checkbox v-for="item in items" :key="item.id" :value="item.value">{{ item.title }}</b-form-checkbox>
    </b-form-checkbox-group>
  </b-form-group>
</template>

<style lang="scss" scoped>
::v-deep {
  label {
    margin-right: 8px;
  }
}
</style>
